import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    classification: null,                     // The current selected classification
    classifications: [],                      // All the classifications with `{id, name}`
    /* The features of the current classification with `{name, values, metric, color, onlyMissing}` */
    features: [],
    loadingAddTaggedFeatureToProduct: false,  // Is adding a tagged feature to a product
    loadingClassifications: false,            // Is getting the classifications
    loadingCreateFeature: false,              // Is creating a feature
    loadingFeatures: false,                   // Is getting the features of the current classification
    loadingProducts: false,                   // Is getting the products to tag
    loadingRemoveTaggedFeature: false,        // Is removing a tagged feature
    /**
     * The products of the current classification with: {
     *  id: String,
     *  name: String,
     *  nameId: Number,  // Unique identifier of the 'name' feature of this product (i.e. the row id in QMatchingItemFeature)
     *  brand: String,
     *  taggedFeatures: Array with objects like {
     *    id: id of the tag,
     *    featureId: id of the feature,
     *    dataId: identifier of the product's data (not product's id) where the feature is,
     *    offset: The offset from the start of the text in that section where the feature is located,
     *    value: The selected string as feature
     *  },
     *  image: String,
     *  sellerId: Number,
     *  specs: Array with tuples [name, value],
     *  url: String
     * }
     * 
     */
    products: [],
    productsPage: 0,            // The last page got from the backend
    productsPagesLength: null,  // How many pages does the current active classification have 
    searchInput: null,          // The value of the search in the toolbar
    selectedFeature: null,      // The feature object selected with the feature selector of the toolbar
    selection: null,            // The selection object with {dataId, offset, product, position: {x, y}, value}
    show: {
      sidebar: true             // Controls the visibility of the sidebar
    }
  }
}
